import React, { useState } from "react";
import { LinkUnitToHSN } from "./SubComponents/LinkUnitToHSN";
import CreateUnit from "./SubComponents/CreateUnit";

import "../../../assets/styles/ServiceStyles/UnitSettingsStyles/UnitSettings.css";
// import "../../../assets/styles/ProductStyles/UnitSettingsStyles/UnitSettings.css";

export default function ServiceUnitSettings() {
  // State to track the active link
  const [activeLink, setActiveLink] = useState("createUnit");

  // Function to handle link click and set active state
  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  return (
    <div>
      {/* Buttons for navigation */}
      <div className="flex items-center gap-10 px-3">
        <button
          type="button"
          className={`text-[#667085] font-bold text-[16px] ${
            activeLink === "createUnit" ? "unit-nav" : ""
          }`}
          style={{ background: "none", border: "none", cursor: "pointer" }}
          onClick={() => handleLinkClick("createUnit")}
        >
          Create Unit
        </button>
        <button
          type="button"
          className={`text-[#667085] font-bold text-[16px] ${
            activeLink === "linkUnit" ? "unit-nav" : ""
          }`}
          style={{ background: "none", border: "none", cursor: "pointer" }}
          onClick={() => handleLinkClick("linkUnit")}
        >
          Link Unit to HSN
        </button>
      </div>

      {/* Render the active component based on the state */}
      <div className="px-3">
        {activeLink === "createUnit" ? <CreateUnit /> : <LinkUnitToHSN />}
      </div>
    </div>
  );

  return(
  <div>
    {/* Buttons for navigation */}
    <div className="flex items-center gap-10 px-3">
      <button
        type="button"
        className={`text-[#667085] font-bold text-[16px] ${
          activeLink === "createUnit" ? "unit-nav" : ""
        }`}
        style={{ background: "none", border: "none", cursor: "pointer" }}
        onClick={() => handleLinkClick("createUnit")}
      >
        Create Unit
      </button>
      <button
        type="button"
        className={`text-[#667085] font-bold text-[16px] ${
          activeLink === "linkUnit" ? "unit-nav" : ""
        }`}
        style={{ background: "none", border: "none", cursor: "pointer" }}
        onClick={() => handleLinkClick("linkUnit")}
      >
        Link Unit to SAC
      </button>
    </div>

    {/* Render the active component based on the state */}
    <div className="px-3">
      {activeLink === "createUnit" ? <CreateUnit /> : <LinkUnitToHSN />}
    </div>
  </div>
      )
}
